import { render, staticRenderFns } from "./InputWrap.vue?vue&type=template&id=49b8668b&scoped=true&"
import script from "./InputWrap.vue?vue&type=script&lang=ts&"
export * from "./InputWrap.vue?vue&type=script&lang=ts&"
import style0 from "./InputWrap.vue?vue&type=style&index=0&id=49b8668b&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b8668b",
  null
  
)

export default component.exports